import { Request } from "@/utils/request";

export function buriedPoint (data: any)  {
    return Request.axiosInstance({
        url: '/website-portal/buriedPoint/create',
        method: 'post',
        data: data,
    })
}
